module.exports = __webpack_public_path__ + "static/aquarius-752b59daaf43a6837a635f58e3b679da.jpg";